<template>
  <div class="app">
    <slot />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/layout/partials/Footer.vue";

export default {
  name: "Default-Layout",
  components: {
    Footer,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
